import { inject } from '@angular/core';
import { Router, CanActivateFn } from '@angular/router';
import { EMergeType, IMergeItem } from '@app/pages/merge/model/merge-item.interface';
import { MergeService } from '@app/pages/merge/service/merge.service';
import { htmlUrls } from '@shared/utils/router-paths';
import { Observable, of } from 'rxjs';


export const mergeBookGuard: CanActivateFn = (): Observable<boolean> => {
  const mergeService: MergeService = inject(MergeService);
  const router: Router = inject(Router);
  const itemIds: string[] = [];

  const mergeItems = [mergeService.GetAuthorsMergeList, mergeService.GetPublisherMergeList, mergeService.GetBookMergeList].find(list => list?.length > 0) ?? [];
  mergeItems.forEach(item => {
    itemIds.push(item.id)
  });


  if (mergeItems[0]?.type === EMergeType.book) {
    let selectedBooks: IMergeItem[] = [];
    mergeService.selectedBookToMerge.subscribe(res => {
      selectedBooks = res;
    });

    if (selectedBooks?.length < 2 || !selectedBooks) {
      router.navigate([htmlUrls.feed]);
      return of(false);
    }
  }
  return of(true);
};



